import { webCampaign } from './webCampaign';

export type ColorSchemeType = 'light' | 'dark';

class ColorScheme {
  theme: ColorSchemeType = 'light';
  isThemeStatic = false;

  init() {
    const theme = this.getTheme();

    this.theme = theme;

    this.toggleBodyClass(theme);
    this.addListener();
  }

  getTheme(): ColorSchemeType {
    return webCampaign.setup.theme;

    // const scheme = window.matchMedia('(prefers-color-scheme: dark)');
    // return scheme.matches ? 'dark' : 'light';
  }

  private toggleBodyClass(theme: ColorSchemeType) {
    if (theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }

  private getThemeFromParams(): ColorSchemeType | null {
    const theme = new URLSearchParams(window.location.search).get('theme');

    if (theme && ['dark', 'light'].includes(theme)) {
      return theme as ColorSchemeType;
    }

    return null;
  }

  private addListener() {
    const scheme = window.matchMedia('(prefers-color-scheme: dark)');

    scheme.addEventListener('change', (event) => {
      if (this.isThemeStatic) {
        return;
      }

      if (event.matches) {
        document.body.classList.add('dark');
        this.dispatchThemeChange('dark');
        this.theme = 'dark';
      } else {
        document.body.classList.remove('dark');
        this.dispatchThemeChange('light');
        this.theme = 'light';
      }
    });
  }

  private dispatchThemeChange(theme: ColorSchemeType) {
    window.dispatchEvent(new CustomEvent('theme-change', { detail: theme }));
  }
}

export const colorScheme = new ColorScheme();
